import React from "react";
import { WrapperGoal } from "./GoalSection.styles";

export const GoalSection = () => {
  return (
    <>
      <WrapperGoal>
        <div>
          <h1>Bonpellz ultimate goal</h1>

          <p>
            The aim is to help the next generation of the african children
            achieve future desired goals with ease through the provision of an
            already made available funds or become stakeholders in the emerging
            african economy via syndicate investment, these children funds are
            pooled together to make equity investment into startups in exchange
            for equity shares, this will also help startup founders around the
            continent to easily achieve their goals, so we are holistically
            grooming a new prosperous African people and economy.
          </p>
        </div>
      </WrapperGoal>
    </>
  );
};
